"use client";

import LegacyPurchaseSettings from "@/components/settings/LegacyPurchaseSettings";

/** 결제·이메일·PDF 상세의 기존 링크에서도 구매 설정을 연다. */
export default function PurchasesRoute() {
  return <LegacyPurchaseSettings section="purchases" />;
}
